export default __webpack_public_path__ + "static/media/home_img_bg.36e999b6.png";